<nav id="mainNav" [class.scrolled]="scrolled">
  <ul class="nav-links nav-links--left">
    <li><a href="#amenities">Amenities</a></li>
    <li><a href="#residences">Residences</a></li>
    <li><a href="#dream-team">Team</a></li>
  </ul>

  <a class="nav-logo" href="#">
    <img src="/logo/acacia_gold_logo.png" alt="Acacia" class="nav-logo-image" />
  </a>

  <ul class="nav-links nav-links--right">
    <li><a href="#rooftop">Rooftop</a></li>
    <li><a href="#location">Location</a></li>
    <li><a href="#contact">Contact</a></li>
  </ul>

  <!-- Hamburger — mobile only -->
  <button class="nav-hamburger" (click)="toggleMobileMenu()" [class.is-open]="mobileMenuOpen" aria-label="Toggle menu">
    <span></span>
    <span></span>
    <span></span>
  </button>
</nav>

<!-- Mobile drawer -->
@if (mobileMenuOpen) {
  <div class="mobile-menu-backdrop" (click)="closeMobileMenu()"></div>
  <div class="mobile-menu" [class.is-open]="mobileMenuOpen">
    <button class="mobile-menu-close" (click)="closeMobileMenu()" aria-label="Close menu">&#x2715;</button>
    <nav class="mobile-menu-links">
      <a href="#amenities"   (click)="closeMobileMenu()">Amenities</a>
      <a href="#residences"  (click)="closeMobileMenu()">Residences</a>
      <a href="#rooftop"     (click)="closeMobileMenu()">Rooftop</a>
      <a href="#location"    (click)="closeMobileMenu()">Location</a>
      <a href="#dream-team"  (click)="closeMobileMenu()">Team</a>
      <a href="#contact"     (click)="closeMobileMenu()">Contact</a>
    </nav>
    <button class="mobile-menu-cta" (click)="openEnquire()">Enquire Now</button>
  </div>
}

<!-- Brochure Modal -->
@if (brochureOpen) {
  <div class="enquire-backdrop" (click)="closeBrochure()">
    <div class="enquire-modal" (click)="$event.stopPropagation()">
      <button class="enquire-close" (click)="closeBrochure()" aria-label="Close">&#x2715;</button>

      <p class="enquire-eyebrow">Your Free Copy</p>
      <h2 class="enquire-title">Download Brochure</h2>
      <p class="enquire-sub">Enter your details and your brochure will download instantly.</p>

      <form class="enquire-form" (ngSubmit)="submitBrochure()" #brochureFormRef="ngForm">
        <input type="text" class="full" placeholder="Full Name" name="name" [(ngModel)]="brochureForm.name" required />
        <input type="email" class="full" placeholder="Email Address" name="email" [(ngModel)]="brochureForm.email" required />
        <input type="tel" class="full" placeholder="Phone Number" name="phoneNumber" [(ngModel)]="brochureForm.phoneNumber" />
        <input type="text" class="full" placeholder="Company (optional)" name="company" [(ngModel)]="brochureForm.company" />
        <button type="submit" class="enquire-submit full">Download Now</button>
      </form>
      <img src="/backgrounds/twig.webp" alt="" class="modal-twig" aria-hidden="true" />
    </div>
  </div>
}

<!-- Enquiry Modal -->
@if (enquireOpen) {
  <div class="enquire-backdrop" (click)="closeEnquire()">
    <div class="enquire-modal" (click)="$event.stopPropagation()">
      <button class="enquire-close" (click)="closeEnquire()" aria-label="Close">&#x2715;</button>

      <p class="enquire-eyebrow">Begin Your Journey</p>
      <h2 class="enquire-title">Reserve Your Unit</h2>
      <p class="enquire-sub">Our team will reach you within 24 hours.</p>

      <form class="enquire-form" (ngSubmit)="submitEnquire()" #enquireForm="ngForm">
        <input type="text" class="full" placeholder="Full Name" name="name" [(ngModel)]="form.name" required />
        <input type="email" class="full" placeholder="Email Address" name="email" [(ngModel)]="form.email" required />
        <input type="tel" class="full" placeholder="Phone Number" name="phoneNumber" [(ngModel)]="form.phoneNumber" />
        <input type="text" class="full" placeholder="Company (optional)" name="company" [(ngModel)]="form.company" />
        <textarea class="full" placeholder="Any specific requirements..." name="message" [(ngModel)]="form.message"></textarea>
        <button type="submit" class="enquire-submit full">Send Enquiry</button>
      </form>
      <img src="/backgrounds/twig.webp" alt="" class="modal-twig" aria-hidden="true" />
    </div>
  </div>
}
